import { post, get } from 'lib/API';

/**
 * Chatbot request payload
 */
export interface ChatbotRequest {
  question: string;
}

/**
 * Chatbot response from the backend
 */
export interface ChatbotResponse {
  question: string;
  answer: string;
  timestamp: string;
  sessionId?: string; // Session ID for maintaining conversation context
  requestLimit?: number; // Daily request limit
  requestsUsed?: number; // Requests used today
  remainingRequests?: number; // Remaining requests for today
}

/**
 * Submit a question to the chatbot
 * @param question - The user's question
 * @param sessionId - Optional session ID for maintaining conversation context
 * @param token - Authentication token
 * @returns Promise with the chatbot response
 */
export const sendMessage = async (
  [question, sessionId]: any[],
  { token }: any
): Promise<ChatbotResponse> => {
  const requestBody: any = { question };

  // Include sessionId if provided
  if (sessionId) {
    requestBody.sessionId = sessionId;
  }

  return await post('v1/ai-assistant/chat', token, requestBody);
};

/**
 * Response from the request limits endpoint
 */
export interface ChatbotLimitsResponse {
  requestLimit: number;
  requestsUsed: number;
  remainingRequests: number;
}

/**
 * Fetch the current daily request limit status
 * @param _props - Unused, required by promiseFn signature
 * @param param1 - Contains the auth token
 * @returns Promise with the limits response
 */
export const getRequestLimits = async (
  { token }: any
): Promise<ChatbotLimitsResponse> => {
  return await get('v1/ai-assistant/limits', token);
};

